module.exports = __webpack_public_path__ + "img/timytoys1.c7c1bb59.png";